"use client";

import { m, useInView } from "framer-motion";
import { useRef } from "react";

interface Props {
  data?: any;
}

export default function StepsSection({ data }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
  });

  return (
    <section
      className={`container mx-auto grid md:grid-cols-2 gap-4 section ${data?.darkerBackground ? "bg-neutral-200/50" : ""}`}
      ref={ref}
    >
      <div className="w-full ">
        {data?.title && (
          <div className="md:sticky top-28">
            <h2 className="mono bullet text-left">{data.title}</h2>
          </div>
        )}
      </div>
      <div className="w-full flex flex-col gap-12">
        {data?.items?.map((item: any, index: number) => (
          <m.div
            key={index}
            className={`flex flex-col gap-4 w-full`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, type: "spring" }}
            viewport={{ once: true }}
          >
            <span className="block frame w-10 h-10 flex justify-center items-center mono">
              {(index + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}
            </span>
            <div className="flex gap-4 flex-col">
              <h3 className="h3 uppercase">{item.title}</h3>
              <div className="text-lg">{item.text}</div>
            </div>
          </m.div>
        ))}
      </div>
    </section>
  );
}
